<template>
  <div>
    <Title title="九吨业务"></Title>
    <div class="swiper2 swiper-content">
      <div class="swiper-wrapper">
        <div class="swiper-slide swiper-slide2" v-for="(item, index) in list" :key="index">
          <div class="product-img" :style="{ '--img': `url(${item.extends[2].image})` }">
            <img :src="item.extends[1].image" class="png6" alt="">
            <img :src="item.extends[3].image" class="png8" alt="">
          </div>
          <div class="product-base">
            <img :src="item.extends[0].image" class="png4" alt="">
            <div class="info-wrapper">
              <h1 class="title">
                {{ item.title }}
              </h1>
              <p class="desc">
                {{ item.desc }}
              </p>
              <div class="ac">
                <div class="download-btn ajc" v-if="item.extends[4].h5_android" @click="download(item.extends[4].h5_android)">
                  安卓
                </div>
                <div class="download-btn ajc" @click="download(item.extends[5].h5_ios)" v-if="item.extends[5].h5_ios">
                  iOS
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- 切换按钮 -->
    <div class="cutover space-between ac">
      <div class="left ajc" @click="less" v-if="current != 0">
        <img src="@/assets/img/mobile/20.png" class="right-icon" alt="">
      </div>
      <div v-else class="ajc">
        <img src="@/assets/img/mobile/18.png" class="right-icon" alt="">
      </div>
      <div class="number"><span>{{ current + 1 }}</span> / {{ list.length }}</div>

      <div class="right ajc" @click="add" v-if="current + 1 < list.length">
        <img src="@/assets/img/mobile/21.png" class="right-icon" alt="">
      </div>
      <div v-else class="ajc">
        <img src="@/assets/img/mobile/19.png" class="right-icon" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/js/swiper";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import Title from '@/components/mobile/Title'
export default {
  components: {
    Title
  },
  data() {
    return {
      list: [],
      swiperExa: null,
      current: 0 // 当前索引
    }
  },
  mounted() {
    this.getdata()
  },
  methods: {
    less() {
      if (this.current > 0) {
        this.current -= 1
        this.swiperExa.slideTo(this.current)
      }

    },
    add() {
      if (this.current + 1 < this.list.length) {
        this.current += 1
        this.swiperExa.slideTo(this.current)
      }
    },
    download(url) {
      if (url) {
        // window.open(url)
        window.location.href = url
      }
    },
    async getdata() {
      const [err, res] = await this.$http.get('business')
      if (err) return
      this.list = res.list
      this.$nextTick(() => {
        this.initSwiper();
      })
    },
    initSwiper() {
      const _this = this
      this.swiperExa = new Swiper(".swiper2", {
        // direction: "horizontal", // 垂直切换选项
        on: {
          // 当轮播切换的时候
          slideChange: function () {
            _this.current = this.realIndex
          },
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
.swiper-content {
  overflow: hidden;
  height: 13.5rem;

  @media (max-height:750px) {
    // 小屏幕
    height: 12.8rem;
  }

  .swiper-slide {
    position: relative;

    .product-img {
      width: 4.84rem;
      height: 7.92rem;
      background-image: var(--img);
      background-size: 100% 100%;
      position: relative;
      margin-left: 2.1333rem;
      // margin-top: .0333rem;


      @media (max-height:750px) {
        transform: scale(0.85);
        // background: red;
        // zoom: 0.7;
        // margin-left: 3.7867rem;
      }

      .png6 {
        position: absolute;
        left: -1.8667rem;
        top: 3.2rem;
        width: 4.48rem;
        height: 2.76rem;
        object-fit: contain;
      }

      .png8 {
        position: absolute;
        right: -1.4533rem;
        top: 4.5333rem;
        width: 4.2267rem;
        height: 1.64rem;
        object-fit: contain;
      }

      .title {
        font-weight: bold;
        font-size: .4267rem;
        color: #000;
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 4rem;
        text-align: center;
        transform: translateX(-50%);
      }
    }

    .product-base {
      position: relative;
      top: -1.3333rem;
      padding-left: .6667rem;
      box-sizing: border-box;

      @media (max-height:750px) {
        top: -2.3333rem;
      }

      .png4 {
        width: 2.2533rem;
        height: 2.2533rem;
      }

      .info-wrapper {
        // padding-left: .4rem;
        box-sizing: border-box;
        font-size: .32rem;
        transform: translateY(-0.3667rem);
        width: 95%;


        .title {
          font-weight: bold;
          font-size: .3733rem;
          margin-bottom: .24rem;

        }

        .desc {
          font-size: .32rem;
          zoom: 0.9;
          line-height: .5667rem;
          margin-bottom: .4rem;
        }

      }

      .download-btn {
        width: 2.1333rem;
        height: .6rem;
        border-radius: .3067rem;
        border: 1px solid #979797;
        margin-right: .4rem;
        color: #979797;

        &:nth-child(1) {
          background: #E28B2B;
          color: #FFF;
          border: none;
          box-shadow: 0 .1333rem .5333rem rgba(226, 139, 43, 0.5);
        }
      }
    }
  }
}

.cutover {
  width: 3.4rem;
  margin: 0.6267rem auto 0;

  .right-icon {
    width: .2667rem;
    height: .2667rem;
  }

  .number {
    font-weight: bold;

    span {
      font-size: .3733rem;
      color: #E28A2B;
    }
  }

  .right,
  .left {
    width: 0.9rem;
    height: 0.9rem;
    background: #E28B2B;
    box-shadow: 0 .1333rem .5333rem rgba(226, 139, 43, 0.5);
    border-radius: .6667rem;
    color: #FFF;
  }
}

.top {
  margin-bottom: .6667rem;
}

.title1 {
  font-weight: 600;
  font-size: .3733rem;
  position: relative;

  &::after {
    content: '';
    width: .4533rem;
    height: .0933rem;
    background: #F7931E;
    border-radius: .0533rem;
    position: absolute;
    left: 0;
    bottom: -.2667rem;
  }
}
</style>